import { render, staticRenderFns } from "./CheckboxRadio.vue?vue&type=template&id=449615a4&scoped=true"
import script from "./CheckboxRadio.vue?vue&type=script&lang=ts"
export * from "./CheckboxRadio.vue?vue&type=script&lang=ts"
import style0 from "./CheckboxRadio.vue?vue&type=style&index=0&id=449615a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449615a4",
  null
  
)

export default component.exports